import { Alert, Platform } from 'react-native';

type PauseItem = { msg: string; resolve: () => void; time: number };

let queue: PauseItem[] = [];
let showing = false;

/**
 * Pausa a execução para debug, mostrando um modal bloqueante.
 * - No mobile: usa Alert.alert
 * - No web: usa window.confirm
 * @param message Mensagem a exibir
 * @param enabled Se false, apenas loga e não pausa
 */
export function debugPause(message = 'Execução pausada', enabled = false): Promise<void> {
    return new Promise<void>(resolve => {
        if (!enabled) {
            console.log(`🔎 Debug pause ignorado: ${message}`);
            resolve();
            return;
        }
        queue.push({ msg: message, resolve, time: Date.now() });
        processQueue();
    });
}

function processQueue() {
    if (showing || queue.length === 0) return;
    const { msg, resolve, time } = queue.shift()!;
    showing = true;
    const ts = new Date(time).toLocaleTimeString('pt-BR', { hour12: false });

    if (Platform.OS === 'web') {
        window.confirm(`🔎 Debug pause [${ts}]\n\n${msg}`);
        showing = false;
        resolve();
        processQueue();
    } else {
        Alert.alert(
            `🔎 Debug pause [${ts}]`,
            msg,
            [
                {
                    text: 'Continuar',
                    style: 'default',
                    onPress: () => {
                        showing = false;
                        resolve();
                        processQueue();
                    },
                },
            ],
            { cancelable: false },
        );
    }
} 